import { IonItem, IonList } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import Trans from 'util/Trans';
import './OptionsPopOver.css';

interface OptionsProps {
  onHide: () => void;
  logOut: () => void;
  checkUpdates?: () => void;
  editRider?: () => void;
  editBoard?: () => void;
  openSettings?: () => void;
  onOpenDebugModal?: () => void;
  onDeleteUser?: () => void;
  onOpenFirmwareTest?: () => void;
}

const OptionsPopOver: React.FC<OptionsProps> = ({
  onHide,
  logOut,
  checkUpdates,
  editRider,
  editBoard,
  openSettings,
  onOpenDebugModal,
  onDeleteUser,
  onOpenFirmwareTest,
}) => {
  const { t } = useTranslation();

  return (
    <div className="options-popover-container">
      <IonList className="popover-menu">
        {/* EDIT PROFILE ITEM */}
        <IonItem
          detail={false}
          button
          onClick={() => {
            editRider?.();
            onHide();
          }}
        >
          <Trans i18nKey="EDIT_PROFILE">Profil bearbeiten</Trans>
        </IonItem>

        {/* EDIT BOARD ITEM */}
        <IonItem
          detail={false}
          button
          onClick={() => {
            editBoard?.();
            onHide();
          }}
        >
          <Trans i18nKey="EDIT_BOARD">Board bearbeiten</Trans>
        </IonItem>

        {/* SETTINGS ITEM */}
        <IonItem
          detail={false}
          button
          onClick={() => {
            openSettings?.();
            onHide();
          }}
        >
          <Trans i18nKey="SETTINGS">Einstellungen</Trans>
        </IonItem>

        {/* ADD: FIRMWARE TEST ITEM (nur im Debug-Modus) */}
        <IonItem
          detail={false}
          button
          onClick={() => {
            onOpenFirmwareTest?.();
            onHide();
          }}
        >
          <Trans i18nKey="FIRMWARE">Firmware</Trans>
        </IonItem>
       

        {/* DEBUG TOOLS ITEM (nur wenn nicht production) */}
        {process.env.NODE_ENV !== 'production' && (
          <IonItem
            detail={false}
            button
            onClick={() => {
              if (typeof onOpenDebugModal === 'function') {
                onOpenDebugModal();
                onHide();
              }
            }}
          >
            <Trans i18nKey="DEBUG_TOOLS">Debug Tools</Trans>
          </IonItem>
        )}

        {/* SEARCH FOR UPDATES ITEM */}
        {/*
        <IonItem
          detail={false}
          button={!!checkUpdates}
          className={!checkUpdates ? 'disabled-option' : ''}
          onClick={() => {
            if (checkUpdates) {
              checkUpdates?.();
              onHide();
            }
          }}
        >
          <span
            style={{
              textDecoration: checkUpdates ? undefined : 'line-through',
            }}
          >
            <Trans i18nKey="SEARCH_FOR_UPDATES">Nach Updates suchen</Trans>
          </span>
        </IonItem>
        */}

        {/* PRIVACY POLICY ITEM */}
        <IonItem
          detail={false}
          href={'https://spinnax.com/datenschutzerklaerung-der-spinnax-app/'}
        >
          <Trans i18nKey="PRIVACY_POLICY">Datenschutz</Trans>
        </IonItem>

        {/* TERMS OF SERVICE ITEM */}
        <IonItem detail={false} href={'https://spinnax.com/manual-freak/'}>
          <Trans i18nKey="INSTRUCTIONS">Anleitung</Trans>
        </IonItem>

        {/* SPINNAX SHOP ITEM */}
        <IonItem
          detail={false}
          href={t('SHOP_URL', { defaultValue: 'https://spinnax.com' })!}
        >
          <Trans i18nKey="SHOP">Spinnax Shop</Trans>
        </IonItem>

        {/* LOGOUT ITEM */}
        <IonItem
          detail={false}
          button
          onClick={() => {
            logOut();
            onHide();
          }}
        >
          <Trans i18nKey="LOGOUT">Ausloggen</Trans>
        </IonItem>

        <IonItem
          detail={false}
          button
          onClick={() => {
            onDeleteUser?.();
            onHide();
          }}
          className="danger-option"
        >
          <Trans i18nKey="DELETE_ACCOUNT">Profil löschen</Trans>
        </IonItem>
      </IonList>
    </div>
  );
};

export default OptionsPopOver;
